'use strict';

/**
 * Base class for a localstorage model
 *
 * @category   Model
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Backbone = require('backbone');

require('backbone-localstorage');

var ModelLocal = Backbone.Model.extend({

    /**
     * Set the default id to 1
     */
    defaults: {
        id: 1,
    },

    /**
     * Name of the storage to use
     * @type {string|null}
     */
    storageKey: null,

    /**
     * The localstorage for this model
     * @type {Backbone.LocalStorage|null}
     */
    localStorage: null,

    /**
     * Initialize model
     * @param {object} attributes The initial attributes for the model
     * @param {object} options The options for the model
     */
    initialize: function(attributes, options) {
        // Has options?
        if (typeof options === 'object') {
            // Storage Key given?
            if (options.hasOwnProperty('storageKey')) {
                this.storageKey = options.storageKey;
            }

            // localStorage given?
            if (options.hasOwnProperty('localStorage')) {
                this.localStorage = options.localStorage;
            }

            // Set implicit ID = 1
            if (!options.hasOwnProperty('id')) {
                options.id = 1;
            }
        }

        // Initialize storage?
        if (this.storageKey !== null) {
            this.localStorage = new Backbone.LocalStorage(this.storageKey);
        }

        // Call parent
        Backbone.Model.prototype.initialize.apply(this, arguments);

        // Fetch data on startup
        this.fetch();
    },
});

module.exports = ModelLocal;